import { useState } from 'react';
import { Link } from 'react-router';
import { useConsulta } from '@plataforma/web/api';
import { PiezasVehiculo } from '../componentes/PiezasVehiculo';
import { ETIQUETAS_ESTADO } from '../formato';
import { nombreVehiculo } from './Tablero';
import type { Vehiculo } from './tipos';

/** Un auto se desarma cuando ya está en el patio y su camino es desarmar, o ya empezó el desarme. */
const POR_DESARMAR = new Set(['recibido', 'en_desarme']);

/**
 * Desarme (arquitectura 2.15, rol desarmador): los autos del yonke que toca desarmar, uno a la
 * vez, con el alta de piezas por plantilla o una por una, su estado y su etiqueta. Sin precios de
 * compra ni recuperación: eso lo ve el dueño.
 */
export function Desarmador() {
  const lista = useConsulta<Vehiculo[]>('/inventory/vehiculos');
  const [vehiculoId, setVehiculoId] = useState<string | null>(null);
  const autos = (lista.datos ?? []).filter(
    (v) => !v.baja && (POR_DESARMAR.has(v.estado) || v.estado === 'desarmado'),
  );
  const enTurno = autos.filter((v) => v.estado !== 'desarmado');
  const terminados = autos.filter((v) => v.estado === 'desarmado');
  const elegido = autos.find((v) => v.id === vehiculoId) ?? null;
  return (
    <>
      <div className="encabezado">
        <div>
          <h1>Desarme</h1>
          <div className="subtitulo">
            Elige el auto, da de alta sus piezas con la plantilla del catálogo y etiquétalas
          </div>
        </div>
        <div className="relleno" />
        <Link className="boton" to="/piezas">
          Inventario de piezas
        </Link>
      </div>
      {lista.error && <p className="error">{lista.error}</p>}
      <section className="seccion">
        <header>
          <h2>Por desarmar</h2>
        </header>
        <div className="tarjetas">
          {enTurno.map((v) => (
            <button
              key={v.id}
              className="tarjeta"
              style={{ textAlign: 'left', cursor: 'pointer' }}
              onClick={() => setVehiculoId(v.id)}
              aria-pressed={v.id === vehiculoId}
            >
              <div className="rotulo">{ETIQUETAS_ESTADO[v.estado] ?? v.estado}</div>
              <strong>{nombreVehiculo(v)}</strong>
              <div className="vin">{v.vin}</div>
              {v.camino && v.camino !== 'desarmar' && (
                <div className="nota">
                  Camino: {v.camino} (confirma con el dueño antes de desarmar)
                </div>
              )}
            </button>
          ))}
        </div>
        {!lista.cargando && enTurno.length === 0 && (
          <p className="vacio">No hay autos recibidos o en desarme.</p>
        )}
      </section>
      {elegido && (
        <section className="seccion cuerpo">
          <div className="encabezado">
            <div>
              <h2>
                {nombreVehiculo(elegido)} · <span className="vin">{elegido.vin}</span>
              </h2>
              <div className="subtitulo">
                {ETIQUETAS_ESTADO[elegido.estado] ?? elegido.estado} ·{' '}
                <Link to={`/vehiculos/${elegido.id}`}>ver ficha</Link>
              </div>
            </div>
          </div>
          <PiezasVehiculo vehiculoId={elegido.id} />
        </section>
      )}
      {terminados.length > 0 && (
        <section className="seccion">
          <header>
            <h2>Desarmados</h2>
          </header>
          <table>
            <tbody>
              {terminados.map((v) => (
                <tr key={v.id}>
                  <td>
                    <Link to={`/vehiculos/${v.id}`}>{nombreVehiculo(v)}</Link>
                  </td>
                  <td className="vin">{v.vin}</td>
                  <td>
                    <button className="boton" onClick={() => setVehiculoId(v.id)}>
                      Ver piezas
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </>
  );
}
